import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import StepConnector from "@material-ui/core/StepConnector";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import clsx from "clsx";
import PropTypes from "prop-types";

//Icons
import AddAPhotoOutlinedIcon from "@material-ui/icons/AddAPhotoOutlined";
import PhotoSizeSelectLargeOutlinedIcon from "@material-ui/icons/PhotoSizeSelectLargeOutlined";
import FontDownloadOutlinedIcon from "@material-ui/icons/FontDownloadOutlined";
import SystemUpdateAltOutlinedIcon from "@material-ui/icons/SystemUpdateAltOutlined";
import Button from "@material-ui/core/Button";

//Line
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 16,
  },
  active: {
    "& $line": {
      backgroundImage:
        " linear-gradient(90deg, rgba(106,106,106,1) 100%, rgba(0,0,0,1) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        " linear-gradient(90deg, rgba(106,106,106,1) 100%, rgba(0,0,0,1) 100%)",
      // " linear-gradient(90deg, rgba(218,255,0,1) 0%, rgba(152,152,152,1) 35%, rgba(106,106,106,1) 65%, rgba(0,0,0,1) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#333333",
    // backgroundColor: '#8d8e8e',
    // backgroundImage:
    //   "linear-gradient(90deg, rgba(218,255,0,1) 0%, rgba(152,152,152,1) 35%, rgba(106,106,106,1) 65%, rgba(0,0,0,1) 100%);",
    borderRadius: 1,
  },
})(StepConnector);

/*
 * Icon
 */

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#333333",
    zIndex: 1,
    color: "black",
    width: 35,
    height: 35,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": { boxShadow: "0 0px 12px 0  rgba(255,255,255,0.75)" },
  },
  active: {
    // backgroundImage:
    //   "linear-gradient(90deg, rgba(218,255,0,1) 0%, rgba(152,152,152,1) 100%)",
    backgroundColor: "white",
    boxShadow: "0 0px 12px 0  rgba(255,255,255,0.75) !important",
  },
  completed: {
    backgroundColor: "white",
    // backgroundImage:
    //   "linear-gradient(90deg, rgba(218,255,0,1) 0%, rgba(152,152,152,1) 100%)",
  },
});
function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <AddAPhotoOutlinedIcon fontSize="small" />,
    2: <PhotoSizeSelectLargeOutlinedIcon fontSize="small" />,
    3: <FontDownloadOutlinedIcon fontSize="small" />,
    4: <SystemUpdateAltOutlinedIcon fontSize="small" />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}
ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: "#fff",
  },
}));

function getSteps() {
  return [
    "Upload your Image",
    "Position & Resize your Image",
    "Enter Name & Club Name",
    "Download and Share",
  ];
}

export function CustomStepper(props) {
  const classes = useStyles();
  const steps = getSteps();
  return (
    <div className={classes.root}>
      <div className="buttonDiv">
        <Button
          onClick={() => {
            props.handleBack();
          }}
        >
          {props.activeStep === 0 ? "< Back to Layouts" : "< Back"}
        </Button>
        <Button
          onClick={() => {
            props.handleNext();
          }}
        >
          {props.activeStep === 3 ? "Back to Layouts >" : "Next >"}
        </Button>
      </div>
      <Stepper
        alternativeLabel
        activeStep={props.activeStep}
        style={{ backgroundColor: "transparent" }}
        connector={<ColorlibConnector />}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              onClick={(e) => {
                props.handleStep(index);
              }}
              StepIconComponent={ColorlibStepIcon}
            >
              <div className="stepperLabel">{label}</div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
export default CustomStepper;
